/// <amd-module name="typeahead/core/message/EssErrorMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class EssErrorMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.ess_error";
    }

    constructor( private query: string, private statusCode: string, private responseText: string ) {}

    public getTopic(): string {
        return EssErrorMessage.getTopic();
    }

    public getQuery(): string {
        return this.query;
    }

    public getStatusCode(): string {
        return this.statusCode;
    }

    public getResponseText(): string {
        return this.responseText;
    }
}
